import { z } from 'zod';
import { validateBrazilianPhone } from '@/utils';
import { t } from '@/i18n';

export const modalFormSchema = z.object({
  email: z.string().email(t('pages.accountdetail.components.tabs.contacttab.schema.required')),
  mobile_number: z
    .string()
    .min(1, t('pages.accountdetail.components.tabs.contacttab.schema.required'))
    .refine(value => {
      return validateBrazilianPhone(value);
    }, t('pages.accountdetail.components.tabs.contacttab.schema.invalid_phone')),
});

export type ModalFormData = z.infer<typeof modalFormSchema>;
